'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import text from 'I18n/utils/unescapedText';
import { bindAll } from 'underscore';
import UITextInput from 'UIComponents/input/UITextInput';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIDragHandle from 'UIComponents/draggable/UIDragHandle';
import MenuNode from 'simple-menus-core/models/MenuNode';
import MenuNodeTypes from 'simple-menus-core/enums/MenuNodeTypes';
import { getMenuNode } from 'simple-menus-core/selectors/menuNode';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `simpleMenusLib.components.menuItemOptions.${key}`;
const i18nOptionsKey = (type, key) => `${i18nKey('options')}.${type}.${key}`;
function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    return {
      menuNode: getMenuNode(state, props)
    };
  };
}
const mapDispatchToProps = {};
class MenuNodeItemPreview extends PureComponent {
  constructor(props) {
    super(props);
    bindAll(this, ['getPlaceholderText', 'getOptionsLabel']);
  }
  getPlaceholderText() {
    switch (this.props.menuNode.type) {
      case MenuNodeTypes.URL_LINK:
        {
          return text(i18nOptionsKey(MenuNodeTypes.URL_LINK, 'placeholder'));
        }
      case MenuNodeTypes.PAGE_LINK:
      case MenuNodeTypes.PAGE_LINK_WITH_PARAMS:
        {
          return text(i18nOptionsKey(MenuNodeTypes.PAGE_LINK, 'placeholder'));
        }
      case MenuNodeTypes.NO_LINK:
        {
          return text(i18nOptionsKey(MenuNodeTypes.NO_LINK, 'placeholder'));
        }
      default:
        {
          return null;
        }
    }
  }
  getOptionsLabel() {
    const {
      menuNode
    } = this.props;
    switch (menuNode.type) {
      case MenuNodeTypes.URL_LINK:
        {
          return menuNode.linkUrl;
        }
      case MenuNodeTypes.PAGE_LINK:
      case MenuNodeTypes.PAGE_LINK_WITH_PARAMS:
        {
          return menuNode.pageLinkName;
        }
      case MenuNodeTypes.NO_LINK:
        {
          return text(i18nOptionsKey(MenuNodeTypes.NO_LINK, 'placeholder'));
        }
      default:
        {
          return null;
        }
    }
  }
  renderLabel() {
    return /*#__PURE__*/_jsx(UITextInput, {
      className: "preview-label",
      defaultValue: this.getOptionsLabel(),
      placeholder: this.getPlaceholderText()
    });
  }
  renderOptions() {
    const {
      menuNode
    } = this.props;
    const renderedLabel = this.renderLabel();
    if (menuNode.type === MenuNodeTypes.PAGE_LINK_WITH_PARAMS) {
      return /*#__PURE__*/_jsxs("div", {
        className: "page-select-with-url-params",
        children: [renderedLabel, /*#__PURE__*/_jsx(UITextInput, {
          placeholder: text(i18nOptionsKey(MenuNodeTypes.PAGE_LINK_WITH_PARAMS, 'placeholder')),
          defaultValue: menuNode.linkParams
        })]
      });
    }
    return renderedLabel;
  }
  render() {
    const {
      menuNode
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "simple-menus-menu-item is--dragging",
      children: /*#__PURE__*/_jsx(UICardWrapper, {
        compact: true,
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(UIDragHandle, {
          position: "start",
          children: /*#__PURE__*/_jsxs("div", {
            className: "simple-menus-menu-item-content",
            children: [/*#__PURE__*/_jsx("div", {
              className: "menu-content-left",
              children: /*#__PURE__*/_jsx("div", {
                className: "simple-menus-menu-item-label",
                children: /*#__PURE__*/_jsx(UITextInput, {
                  use: "on-dark",
                  className: "label-input",
                  defaultValue: menuNode.linkLabel,
                  placeholder: text('simpleMenusLib.components.menuItemLabel.placeholder')
                })
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "menu-content-right",
              children: /*#__PURE__*/_jsx("div", {
                className: "simple-menus-menu-item-options",
                children: /*#__PURE__*/_jsx("div", {
                  className: "menu-options",
                  children: this.renderOptions()
                })
              })
            })]
          })
        })
      })
    });
  }
}
MenuNodeItemPreview.propTypes = {
  menuNode: PropTypes.instanceOf(MenuNode).isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(MenuNodeItemPreview);